// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { configModel } from '@/firebase/firebase-config'

export const GetLeaseOptions = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        lease_options: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        getLeaseOptionsHandler: function() {

            try {

                configModel.doc('lease_options').get()
                .then(doc => {

                    if (!doc.exists) return;

                    /*
                    **  Set the doc prop
                    **  @prop_location: @here
                    */

                    this.lease_options = doc.data();
                    

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Get Lease Options Config from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Config',
                        uid: 'LSNBhSPWjsXVqw8VzPVs',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Get Lease Options Config from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Config',
                    uid: '4D7V7l7K6sTwy0IfAUAc',
                    error: e
                });

            }

        }

    }

}